import { Dialog } from '@mui/material'
import React from 'react'

import StudentQuiz from '../../../pages/student/quiz/StudentQuiz'

const StudentQuizDialog = ( { open } ) => {
    if ( !open ) return null

    return (
        <Dialog open={open} slotProps={{ paper: { sx: { padding: "0", maxWidth: "1024px" } } }}>
            <StudentQuiz page={false} />
        </Dialog>
    )
}

export default StudentQuizDialog